<div class="expansion-list">
  <div class="expansion-panel" *ngFor="let faqItem of list">
    <app-faq-item [faqItem]="faqItem"></app-faq-item>
  </div>

  <p *ngIf="list.length == 0">Sem perguntas correspondentes com a pesquisa</p>
</div>